import React from 'react';
import { ColumnInstance } from 'react-table';

import { locale } from '@trqk/utils';
import { defaultCellWidth } from '@trqk/components/src/table/constants';

import { COLUMN_IDS, EXTRA_CELL_WIDTH } from '../../constants';

interface ChannelFooterProps {
    column: ColumnInstance<GapReportAudio>;
}

/**
 * Shows a simple label like "Report Total" to add context to the rest of the footers.
 * @returns JSX
 */
export const ChannelFooter = ({ column }: ChannelFooterProps): JSX.Element => {
    const colWidth =
        typeof column.width === 'number' ? column.width : defaultCellWidth;
    // See notes in ../constants about this extra width
    const width = colWidth + EXTRA_CELL_WIDTH[COLUMN_IDS.CHANNEL_NAME];

    return (
        <p
            className="pl-4"
            style={{
                width,
            }}
        >
            {locale.enUS.GAP_ANALYSIS.REPORT_VIEWER_TABLE.FOOTERS.CHANNEL_NAME}
        </p>
    );
};
